
import gtm from '@/mixins/gtm'
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import { head } from '@/utils/head'

export default {
  mixins: [gtm],

  data() {
    return {
      gtmSubsection2: 'PrivacyPolicy',
    }
  },

  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    let title = this.$t('seo.shared.titleTemplate', { title: ' - Privacy Notice' })
    const description = this.$t('seo.shared.descriptionTemplate', { description: title })
    const url = `${process.env.BASE_URL}${this.$route.path}`
    const canonical = url

    return head({
      title,
      description,
      url,
      canonical,
      htmlAttrs: { ...i18nHead.htmlAttrs },
      link: SEO.linkAlternate.setList(this.$route.name),
      breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
    })
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
